import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "form",
  class: "grid grid-cols-6 gap-6 mt-6"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6 border-t border-gray-200" }, null, -1)
const _hoisted_3 = { class: "col-span-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "block text-xs font-semibold text-neutral-600" }, [
  /*#__PURE__*/_createTextVNode("Residence Type "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-600" }, "*")
], -1)
const _hoisted_5 = { class: "flex flex-wrap items-center md:pt-5 pt-2 gap-x-6 gap-y-3" }
const _hoisted_6 = { class: "col-span-6" }
const _hoisted_7 = { class: "md:col-span-3 col-span-6" }
const _hoisted_8 = { class: "md:col-span-3 col-span-6" }
const _hoisted_9 = { class: "md:col-span-3 col-span-6" }
const _hoisted_10 = { class: "md:col-span-3 col-span-6" }
const _hoisted_11 = { class: "col-span-6" }
const _hoisted_12 = { class: "col-span-6" }

import { ref, type PropType, computed, onMounted, watch } from "vue";

import TextInput from "@/components/inputs/TextInput.vue";
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import { renderSelect } from "@/interfaces/DropdownInterface";
import { PatientAddressCreate } from "@/classes/Cases/CasePatientAddress/Offline/Interface/CasePatientInterface";
import MultiSelect from "@/components/inputs/MultiSelect.vue";
import DropdownService from "@/classes/Dropdowns/DropdownService";
import { useNetworkStore } from "@/store/network";
import FormOptions from "@/classes/Forms/FormOptions";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormSection',
  props: {
	form: {
		type: Object as PropType<PatientAddressCreate>,
		required: true,
	},
	errors: {
		type: Object,
		required: true,
	},
	residenceTypes: {
		type: [] as PropType<any>,
		default: [],
	},
},
  emits: ['update:form'],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const regions = ref<any>([]);
const provinces = ref<any>([]);
const cities = ref<any>([]);
const barangays = ref<any>([]);

const form = ref<PatientAddressCreate>(props.form);
const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);
const options = new FormOptions();

const getRegions = async (): Promise<any> => {
    if (isNetworkAvailable.value) {
        DropdownService
        .regions()
        .then(({data}) => {
            regions.value = data;
        })
    } else {
        regions.value = await options.regions()
    }
}

const getProvince = async (): Promise<any> => {
    if(form.value.region_id){
        if (isNetworkAvailable.value) {
            DropdownService
            .provinces(form.value.region_id)
            .then(({data}) => {
                provinces.value = data;
            })
        } else {
            provinces.value = await options.provinces(form.value.region_id)
        }
    }
}

const getCity = async (): Promise<any> => {
    if(form.value.province_id){
        if (isNetworkAvailable.value) {
            DropdownService
            .cities(form.value.province_id)
            .then(({data}) => {
                cities.value = data;
            })
        } else {
            cities.value = await options.cities(form.value.province_id);
        }
    }
}

const getBrangay = async (): Promise<any> => {
    if(form.value.city_id){
        if (isNetworkAvailable.value) {
            DropdownService
            .barangays(form.value.city_id)
            .then(({data}) => {
                barangays.value = data;
            })
        } else {
            barangays.value = await options.barangays(form.value.city_id);
        }
    }
}

const regionChange = ():void => {
    form.value.city_id = null
    form.value.barangay_id = null
    form.value.province_id = null
    getProvince()
}

const provinceChange = ():void => {
    form.value.city_id = null
    form.value.barangay_id = null
    getCity()
}

const cityChange = ():void => { 
    form.value.barangay_id = null
    getBrangay()
}

watch(
    form.value,
    () => {
        emit('update:form', form.value);
    }
);

onMounted(() => {
    getRegions() 
    if(form.value.id){
        getProvince();
        getCity();
        getBrangay();
    }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(RadioGroup, {
          options: __props.residenceTypes,
          name: "residence_type",
          required: "",
          modelValue: form.value.residence_type,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.residence_type) = $event)),
          error: __props.errors?.residence_type
        }, null, 8, ["options", "modelValue", "error"])
      ]),
      (__props.errors?.residence_type)
        ? (_openBlock(), _createElementBlock("p", {
            key: 0,
            class: _normalizeClass(["text-[10px] mt-1", __props.errors?.residence_type ? 'text-red-600' : 'text-gray-800']),
            id: "email-error"
          }, _toDisplayString(__props.errors?.residence_type), 3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(TextInput, {
        type: "text",
        label: "Address",
        placeholder: "Address",
        name: "address",
        id: "address",
        required: "",
        modelValue: form.value.address,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.address) = $event)),
        error: __props.errors?.address
      }, null, 8, ["modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(MultiSelect, {
        options: regions.value,
        id: "region",
        name: "region",
        label: "Region",
        placeholder: "Select..",
        searchable: "",
        required: "",
        modelValue: form.value.region_id,
        "onUpdate:modelValue": [
          _cache[2] || (_cache[2] = ($event: any) => ((form.value.region_id) = $event)),
          _cache[3] || (_cache[3] = ($event: any) => (regionChange()))
        ],
        error: __props.errors?.region_id
      }, null, 8, ["options", "modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(MultiSelect, {
        options: provinces.value,
        id: "province",
        name: "province",
        label: "Province",
        placeholder: "Select..",
        searchable: "",
        required: "",
        modelValue: form.value.province_id,
        "onUpdate:modelValue": [
          _cache[4] || (_cache[4] = ($event: any) => ((form.value.province_id) = $event)),
          _cache[5] || (_cache[5] = ($event: any) => (provinceChange()))
        ],
        error: __props.errors?.province_id
      }, null, 8, ["options", "modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(MultiSelect, {
        options: cities.value,
        id: "city",
        name: "city",
        label: "City/Municipality/District",
        placeholder: "Select..",
        searchable: "",
        required: "",
        modelValue: form.value.city_id,
        "onUpdate:modelValue": [
          _cache[6] || (_cache[6] = ($event: any) => ((form.value.city_id) = $event)),
          _cache[7] || (_cache[7] = ($event: any) => (cityChange()))
        ],
        error: __props.errors?.city_id
      }, null, 8, ["options", "modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(MultiSelect, {
        options: barangays.value,
        id: "barangay",
        name: "barangay",
        label: "Barangay",
        placeholder: "Select..",
        searchable: "",
        modelValue: form.value.barangay_id,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.barangay_id) = $event)),
        error: __props.errors?.barangay_id
      }, null, 8, ["options", "modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(TextInput, {
        textarea: "",
        label: "Direction",
        placeholder: "Direction",
        name: "direction",
        id: "direction",
        modelValue: form.value.direction,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.direction) = $event)),
        error: __props.errors?.direction
      }, null, 8, ["modelValue", "error"])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(TextInput, {
        textarea: "",
        label: "Remarks",
        placeholder: "Remarks",
        name: "remarks",
        id: "remarks",
        modelValue: form.value.remarks,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.remarks) = $event)),
        error: __props.errors?.remarks
      }, null, 8, ["modelValue", "error"])
    ])
  ]))
}
}

})